import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  ContentContainerProps,
  ContentDescriptionProps,
  ContentGroupProps,
  ContentTitleProps,
  ProjectPageMainContentProps,
} from "./props";

export const ProjectPageContainer = styled.div`
  font-size: 1.2em;
  color: var(--text);
`;

export const ProjectPageMainContent = styled.div<ProjectPageMainContentProps>`
  box-sizing: border-box;
  max-width: 1080px;
  margin: 0 auto;
  padding: ${(props) => (props.isHavingPadding ? "50px" : "0px")};
  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    padding: 0px 24px;
    margin-top: 56px;
  }
`;

export const ProjectPageSubContent = styled.div`
  box-sizing: border-box;
  max-width: 1080px;
  margin: 0 auto;
  padding: 50px;
  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    min-width: 0;
    padding: 36px 24px 0px;
  }
`;

export const ProjectTitleGroup = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 24px;
  }
`;

export const ProjectTitle = styled.h1`
  font-size: 64px;
  font-weight: 600;
  @media (max-width: 768px) {
    margin: 0px 0px 10px;
    font-size: 40px;
    line-height: 44px;
  }
`;

export const ProjectSubTitle = styled.label`
  font-size: 24px;
  font-weight: 400;
  color: var(--muted);
  margin-left: 34px;
  @media (max-width: 768px) {
    font-size: 16px;
    margin-left: 0px;
  }
`;

export const ContentGroup = styled.div<ContentGroupProps>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.isNotHavingOneChildren ? "auto auto" : "auto"};
  grid-column-gap: ${(props) =>
    props.isNotHavingOneChildren ? "80px" : "0px"};
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const MainContentGroup = styled.div<ContentGroupProps>`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 80px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContextContentContainer = styled.div<ContentContainerProps>`
  max-width: ${(props) => (props.isFull ? "1080px" : "500px")};
  min-width: 500px;
  display: ${(props) => (props.isShown ? "block" : "none")};
  @media (max-width: 768px) {
    max-width: none;
    min-width: 0;
  }
`;

export const TeamContentList = styled.ul`
  padding: 0px;
  max-width: 500px;
  min-width: 500px;
  margin: 0px;
  @media (max-width: 768px) {
    max-width: none;
    min-width: 0;
  }
`;

export const TeamContentListItem = styled.li`
  list-style-type: none;
`;

export const ContentContainer = styled.div<ContentContainerProps>`
  max-width: ${(props) => (props.isFull ? "1080px" : "500px")};
  min-width: 500px;
  display: ${(props) => (props.isShown ? "block" : "none")};
  @media (max-width: 768px) {
    max-width: none;
    min-width: 0;
  }
`;

export const ContentTitle = styled.h2<ContentTitleProps>`
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  @media (max-width: 768px) {
    display: ${(props) => (props.isVisible ? "block" : "none")};
    font-size: 20px;
    margin-top: 0px;
    margin-bottom: 16px;
  }
`;

export const ContentDescription = styled.h5<ContentDescriptionProps>`
  line-height: 1.5em;
  text-align: justify;
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 0px;

  a {
    color: var(--project-link);
  }

  @media (max-width: 768px) {
    margin-top: ${(props) => (props.isHavingMargin ? "8px" : "0px")};
    font-size: 16px;
    margin-bottom: 40px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 24px;
    letter-spacing: normal;
    max-width: auto;
    text-align: left;
  }
`;

export const MainImage = styled.img`
  width: 100%;
  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

export const ProtectedPreview = styled.div`
  position: relative;
  max-height: 620px;
  overflow: hidden;
  pointer-events: none;
  user-select: none;

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 86%;
    content: "";
    background: linear-gradient(
      180deg,
      transparent 0%,
      var(--protected-fade-soft) 22%,
      var(--protected-fade-strong) 54%,
      var(--page) 92%
    );
  }
`;

export const AccessBackdrop = styled.section<{ isVisible: boolean }>`
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  margin-top: -178px;
  padding: 150px 20px 100px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    var(--page) 22%,
    var(--page) 100%
  );
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transform: translateY(${(props) => (props.isVisible ? "0" : "72px")});
  transition: opacity 700ms ease, transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const AccessDialog = styled.div`
  width: min(560px, 100%);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 28px 44px 36px;
  background: transparent;
  text-align: center;

  @media (max-width: 560px) {
    padding: 36px 24px 28px;
  }
`;

export const AccessEyebrow = styled.p`
  margin: 0 0 18px;
  color: #138acb;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.01em;
`;

export const AccessTitle = styled.h2`
  margin: 0;
  color: var(--heading);
  font-size: clamp(32px, 5vw, 46px);
  font-weight: 600;
  line-height: 1.06;
  letter-spacing: -0.035em;
`;

export const AccessCopy = styled.p`
  max-width: 410px;
  margin: 20px auto 28px;
  color: var(--subtle);
  font-size: 17px;
  line-height: 1.55;
`;

export const AccessForm = styled.form`
  display: grid;
  gap: 12px;
`;

export const AccessInput = styled.input<{ hasError: boolean }>`
  width: 100%;
  height: 54px;
  box-sizing: border-box;
  padding: 0 18px;
  border: 1px solid ${(props) => (props.hasError ? "#d75252" : "#b8c4c9")};
  border-radius: 14px;
  outline: none;
  background: var(--surface);
  color: var(--heading);
  font: inherit;
  font-size: 17px;

  &:focus {
    border-color: ${(props) => (props.hasError ? "#d75252" : "#138acb")};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.hasError ? "rgba(215, 82, 82, 0.12)" : "rgba(19, 138, 203, 0.12)"};
  }
`;

export const AccessButton = styled.button`
  height: 54px;
  border: 0;
  border-radius: 999px;
  background: var(--heading);
  color: var(--page);
  cursor: pointer;
  font: inherit;
  font-size: 17px;
  font-weight: 500;
  transition: background 160ms ease, transform 160ms ease;

  &:hover:not(:disabled) {
    background: var(--text);
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.68;
  }
`;

export const AccessError = styled.p`
  margin: 2px 0 0;
  color: #b83c3c;
  font-size: 14px;
  line-height: 1.4;
`;

export const AccessHomeLink = styled(Link)`
  display: inline-block;
  margin-top: 24px;
  color: var(--subtle);
  font-size: 15px;
  text-underline-offset: 4px;

  &:hover {
    color: var(--heading);
  }
`;
